import React from 'react';
import { label } from '../../../../../helpers/forms/label';
import { CreateClasseState } from '../../../../../store/reducers/createClasse.reducer';
import { NiveauDef } from '../../../../../types/niveau/niveau.def';
import { FilliereDef } from '../../../../../types/filliere/filliere.def';
import { LabelInput } from '../../../../atoms/Inputs/LabelInput';
import { Select } from '../../../../atoms/Inputs/Select';
import useStyle from './createClasse.style';
import { DateInput } from '../../../../atoms/Inputs/DatePicker/DateInput';
import {
  maxClasseDateChallenge,
  minClasseDateChallenge
} from '../../../../../types/classe/classe.def';

export interface FormCreateClasseTypes {
  classe: CreateClasseState;
  handleChange: (e: { target: { value: string; name: string } }) => void;
  fillieres: Array<FilliereDef>;
  niveaus: Array<NiveauDef>;
}

const FormCreateClasseView = ({
  handleChange,
  classe,
  fillieres,
  niveaus
}: FormCreateClasseTypes) => {
  const classes = useStyle();
  const handleChangeFilliere = value => {
    const e = {
      target: {
        value: value,
        name: 'filliere'
      }
    };
    handleChange(e);
  };
  const handleChangeNiveau = value => {
    const e = {
      target: {
        value: value,
        name: 'niveau'
      }
    };
    handleChange(e);
  };
  const classeDebut = (classe.values.debut as unknown) as string;
  const classeFin = (classe.values.fin as unknown) as string;

  return (
    <>
      <div className={classes.root}>
        <LabelInput
          label={label('classeName')}
          name={'classeName'}
          placeHolder={'Ex: Les génies de la vente, les vendeurs fous...'}
          onChange={handleChange}
          required={true}
          error={classe.errors.classeName}
          value={classe.values.classeName || ''}
        />
        {fillieres && (
          <div className={classes.academieSelectContainer}>
            <p className={classes.academieLabel}>Filière</p>
            <Select
              onChange={handleChangeFilliere}
              value={classe.values.filliere}
              variant="form"
              productsOptions={fillieres}
              initialOptionName={'Choisir une filière'}
              disabledInitialOption
            />
          </div>
        )}
        {niveaus && (
          <div className={classes.academieSelectContainer}>
            <p className={classes.academieLabel}>Niveau</p>
            <Select
              onChange={handleChangeNiveau}
              value={classe.values.niveau}
              variant="form"
              productsOptions={niveaus}
              initialOptionName={'Choisir un niveau'}
              disabledInitialOption
            />
          </div>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div>
          <h2 style={{ textAlign: 'center' }}>
            Dates de l’opération de la classe{' '}
            <span role="img" aria-label="calendrier">
              📆
            </span>
          </h2>
          <p style={{ textAlign: 'center' }}>
            Vous pouvez réduire le temps du challenge si vous le souhaitez
          </p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '50px' }}>
          <DateInput
            label="Début"
            error={classe.errors.debut}
            name="debut"
            value={classeDebut}
            onChange={handleChange}
            minDate={minClasseDateChallenge}
            maxDate={maxClasseDateChallenge}
          />
          <DateInput
            label="Fin"
            error={classe.errors.fin}
            name="fin"
            value={classeFin}
            onChange={handleChange}
            minDate={minClasseDateChallenge}
            maxDate={maxClasseDateChallenge}
          />
        </div>
      </div>
    </>
  );
};

export default FormCreateClasseView;
